"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoSlide = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _Slide = require("../Slide");
var _InfoSlide = _interopRequireDefault(require("./InfoSlide.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const InfoSlide = props => {
  const {
    imageUrl,
    title,
    description
  } = props;
  return /*#__PURE__*/React.createElement(_Slide.Slide, {
    testId: "infoSlide"
  }, /*#__PURE__*/React.createElement(_uiKit.PromoModalMedia, null, /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    className: _InfoSlide.default['image'],
    alt: ""
  })), /*#__PURE__*/React.createElement(_uiKit.PromoModalBody, null, /*#__PURE__*/React.createElement(_uiKit.PromoModalTitle, null, /*#__PURE__*/React.createElement(_uiKit.UIHeading2, null, title)), /*#__PURE__*/React.createElement(_uiKit.PromoModalDescription, null, /*#__PURE__*/React.createElement(_uiKit.UIText1, {
    whiteSpace: "pre-wrap"
  }, description))));
};
exports.InfoSlide = InfoSlide;